function performanceMark(key) {
    if ('performance' in window && 'mark' in window.performance) {
        window.performance.mark(`js-${key}`);
    }
}

export { performanceMark };
